import React from 'react';
import { Grid, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import DesignCard from './DesignCard';

const GridContainer = styled(Grid)(({ theme }) => ({
  justifyContent: 'center',
  marginTop: 0,
  marginLeft: '-8px',
  width: 'calc(100% + 16px)',
  [theme.breakpoints.up('sm')]: {
    marginLeft: '-12px',
    width: 'calc(100% + 24px)'
  }
}));

const GridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  paddingTop: '16px !important',
  paddingLeft: '16px !important',
  '& > *': {
    width: '100%'
  },
  [theme.breakpoints.up('sm')]: {
    paddingTop: '24px !important',
    paddingLeft: '24px !important'
  }
}));

const DesignGrid = ({ designs, onDesignSelect, accountInfo }) => {
  return (
    <GridContainer container spacing={{ xs: 2, sm: 3 }}>
      {designs.map((design, index) => (
        <GridItem key={design.id || index} size={{ xs: 12, sm: 6, md: 4 }}>
          <DesignCard
            design={design}
            onClick={() => onDesignSelect(design)}
            accountInfo={accountInfo}
          />
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default DesignGrid;